// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container__2jWmM","title":"Terms_title__1-x7X","dashes":"Terms_dashes__1Towt"};